import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {Vehicle, VehicleUpdate} from '../../shared/models/vehicle.model';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-edit-vehicle',
    templateUrl: 'form-edit-vehicle.html'
})

export class FormEditVehicleComponent implements OnInit, OnDestroy {
    constructor(private dataStorageService: DataStorageService) {
    }

    @Input() vehicle: Vehicle;

    vehicleForm: FormGroup;

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.vehicleForm = new FormGroup({
            'model': new FormControl(this.vehicle.model),
            'vin': new FormControl(this.vehicle.vin),
            'capacity': new FormControl(this.vehicle.capacity)
        });
    }

    onSubmit() {
        const value = this.vehicleForm.value;
        const newVehicle = new VehicleUpdate(this.vehicle.id, value.model, value.vin, value.capacity);
        this.dataStorageService.updateVehicle(newVehicle)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['error']) {
                    console.log('updating vehicle error');
                } else {
                    alert('vehicle updated. ');
                    location.reload();
                }
            }
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
